import React, { useEffect, useRef } from 'react';
export const PainStorySection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, {
      threshold: 0.1
    });
    const quoteElements = document.querySelectorAll('.quote-block');
    quoteElements.forEach(el => observer.observe(el));
    return () => {
      quoteElements.forEach(el => observer.unobserve(el));
    };
  }, []);
  return <section ref={sectionRef} className="w-full py-20 md:py-32 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white" data-id="element-273">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center" data-id="element-274">
        <div className="space-y-16 md:space-y-24" data-id="element-275">
          <div className="quote-block opacity-0 transition-all duration-1000 ease-in-out" data-id="element-276">
            <div className="relative inline-block mb-6" data-id="element-277">
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-red-500 rounded-full animate-ping" data-id="element-278"></div>
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-red-500 rounded-full" data-id="element-279"></div>
              <span className="text-red-500 text-4xl" data-id="element-280">💔</span>
            </div>
            <p className="text-3xl md:text-5xl font-serif leading-tight tracking-tight" data-id="element-281">
              "Leżałam obok męża i czułam się jak najsamotniejsza kobieta na
              świecie"
            </p>
          </div>
          <div className="quote-block opacity-0 transition-all duration-1000 ease-in-out" data-id="element-282">
            <div className="relative inline-block mb-6" data-id="element-283">
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-red-500 rounded-full animate-ping" data-id="element-284"></div>
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-red-500 rounded-full" data-id="element-285"></div>
              <span className="text-red-500 text-4xl" data-id="element-286">💔</span>
            </div>
            <p className="text-3xl md:text-5xl font-serif leading-tight tracking-tight" data-id="element-287">
              "Mam 46 lat. Czy to już koniec mojej historii?"
            </p>
          </div>
          <div className="quote-block opacity-0 transition-all duration-1000 ease-in-out" data-id="element-288">
            <div className="relative inline-block mb-6" data-id="element-289">
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-red-500 rounded-full animate-ping" data-id="element-290"></div>
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-red-500 rounded-full" data-id="element-291"></div>
              <span className="text-red-500 text-4xl" data-id="element-292">💔</span>
            </div>
            <p className="text-3xl md:text-5xl font-serif leading-tight tracking-tight" data-id="element-293">
              "Czy tak będę umierała - obok kogoś, kto mnie nie widzi?"
            </p>
          </div>
        </div>
        <div className="mt-20 md:mt-32" data-id="element-294">
          <div className="flex items-center justify-center space-x-4" data-id="element-295">
            <div className="h-px w-16 bg-red-500/50" data-id="element-296"></div>
            <div className="relative" data-id="element-297">
              <div className="absolute inset-0 w-full h-full bg-red-500 rounded-full animate-ping opacity-25" data-id="element-298"></div>
              <svg className="w-8 h-8 text-red-500 relative z-10" fill="currentColor" viewBox="0 0 20 20" data-id="element-299">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" data-id="element-300" />
              </svg>
            </div>
            <div className="h-px w-16 bg-red-500/50" data-id="element-301"></div>
          </div>
          <p className="text-xl text-gray-400 mt-6 italic" data-id="element-302">
            Ale jak Magda to zmieniła?
          </p>
        </div>
      </div>
      <style jsx data-id="element-303">{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 1.2s forwards;
        }
      `}</style>
    </section>;
};